module.exports = __webpack_public_path__ + "img/SYS-alt.8003fa99.svg";